// extracted by mini-css-extract-plugin
export var dividerLine = "_6r-3";
export var itemImage = "_6r-9";
export var lightDivider = "_6r-4";
export var modalContent = "_6r-5";
export var modalContentCompact = "_6r-6";
export var productCard = "_6r-a";
export var productImage = "_6r-b";
export var productImageCompact = "_6r-7";
export var productImagePlaceholder = "_6r-c";
export var productImagePlaceholderCompact = "_6r-8";
export var progressBarBackground = "_6r-1";
export var progressBarContainer = "_6r-0";
export var progressBarFill = "_6r-2";